export const TIMELINE_CHANGE_TYPES = {
  STATUS: 'status',
  ADDED: 'added',
  DELETED: 'deleted',
  UPDATED: 'updated'
}
